(function() { module.exports = window["wp"]["compose"]; }());